import React, { useState } from 'react';
import { useTranslator, useUrlLocalizer } from 'tradera/lang/translate';
import styles from './similar-sellers-suggestions-modal.module.scss';
import { followSeller, unfollowSeller } from './api';
import { Button } from 'tradera/components/atoms/button/button';
import useIsLoggedIn from 'tradera/hooks/use-is-loggedin';
import { GtmService } from 'tradera/services/google-tagmanager-service';

const SimilarSellersSuggestionsSeller = ({ seller }) => {
    const { toLocalizedUrl } = useUrlLocalizer();

    const trackFollowSellerClick = (sellerId) => {
        GtmService.trackAction(
            'User Profile',
            'Similar Seller',
            sellerIsFollowed ? 'Unfavourite' : 'Favourite',
            sellerId
        );
    };

    const [sellerIsFollowed, setSellerIsFollowed] = useState(
        seller.existsInFavouriteSellers
    );

    const { t } = useTranslator();
    const isLoggedIn = useIsLoggedIn();
    const toggleSeller = (sellerId) => {
        if (!sellerIsFollowed) {
            followSeller(sellerId)
                .then(() => setSellerIsFollowed(true))
                .then(() => trackFollowSellerClick(sellerId))
                .catch(() => {});
        } else {
            unfollowSeller(sellerId)
                .then(() => setSellerIsFollowed(false))
                .then(() => trackFollowSellerClick(sellerId))
                .catch(() => {});
        }
    };

    const profileUrl = toLocalizedUrl(`${seller.sellerProfileUrl}`);

    return (
        <div className="pb-3" key={seller.sellerId}>
            <div className="d-flex flex-row align-items-center">
                {seller.heroImage && (
                    <a className="mr-2" href={profileUrl}>
                        <img
                            className={`${styles.similarSellersListSellerImage}`}
                            src={`https://img.tradera.net/heroimages/small-square/${seller.heroImage}`}
                            alt=""
                        />
                    </a>
                )}
                <div
                    className={`flex-grow-1 mr-1 ${styles.similarSellersListSellerInfo}`}>
                    <div className="d-flex flex-row align-items-center">
                        <a
                            className="heading-paris text-styled text-truncate text-dark m-0"
                            href={profileUrl}>
                            {seller.sellerAlias}
                        </a>
                    </div>
                    <a className="text-dark" href={profileUrl}>
                        {seller.matchedItems
                            ? t('similarSellersSuggestions_numberofitems', {
                                  count: seller.matchedItems
                              })
                            : t('similarSellersSuggestions_noitems')}
                    </a>
                </div>
                <div>
                    <Button
                        theme="action"
                        variant={sellerIsFollowed ? 'filled' : 'outline'}
                        onClick={() => toggleSeller(seller.sellerId)}
                        disabled={!isLoggedIn}
                        nowrap>
                        {!sellerIsFollowed
                            ? t('similarSellersSuggestions_follow')
                            : t('similarSellersSuggestions_following')}
                    </Button>
                </div>
            </div>
        </div>
    );
};
export default SimilarSellersSuggestionsSeller;
